import qs from "qs";
import axios from "axios";

const url = process.env.VUE_APP_API_BASE_URL;

function getReport(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/dashboard/products-report`, options).then((response) => {
    return {
      data: response.data.data,
      meta: response.data.meta,
    };
  });
}

function getAllReport(params) {
  const options = {
    params: { ...params, per_page: 100, page: 1 },
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/dashboard/products-report`, options).then(async (response) => {
    let allData = response.data.data;
    const meta = response.data.meta;
    const lastPage = meta?.page?.last_page || 1;

    for (let page = 2; page <= lastPage; page++) {
      const pageOptions = {
        params: { ...params, per_page: 100, page },
        paramsSerializer: function (params) {
          return qs.stringify(params, { encode: false });
        },
      };
      const pageResponse = await axios.get(`${url}/dashboard/products-report`, pageOptions);
      allData = allData.concat(pageResponse.data.data);
    }

    return { data: allData, meta };
  });
}

export default {
  getReport,
  getAllReport,
};
